import { Options } from 'react-select';

export interface Option extends Options<Option> {
  value: string;
  label: string;
}

export enum DocumentTranslationLanguage {
  Albanian = 'SQ',
  Arabic = 'AR',
  Bengali = 'BN',
  Bulgarian = 'BG',
  Burmese = 'MY',
  Catalan = 'CA',
  Chinese = 'ZH',
  Croatian = 'HR',
  Czech = 'CS',
  Danish = 'DA',
  Dutch = 'NL',
  English = 'EN',
  Estonian = 'ET',
  Finnish = 'FI',
  French = 'FR',
  Galician = 'GL',
  German = 'DE',
  Greek = 'EL',
  Gujarati = 'GU',
  Hebrew = 'HE',
  Hindi = 'HI',
  Hungarian = 'HU',
  Icelandic = 'IS',
  Indonesian = 'ID',
  Italian = 'IT',
  Irish = 'GA',
  Japanese = 'JA',
  Kannada = 'KN',
  Khmer = 'KM',
  Korean = 'KO',
  Lao = 'LO',
  Latvian = 'LV',
  Lithuanian = 'LT',
  Malay = 'MS',
  Malayalam = 'ML',
  Maltese = 'MT',
  Marathi = 'MR',
  Nepali = 'NE',
  Norwegian = 'NB',
  Persian = 'FA',
  Polish = 'PL',
  Portuguese = 'PT',
  Punjabi = 'PA',
  Romanian = 'RO',
  Russian = 'RU',
  Sinhala = 'SI',
  Slovak = 'SK',
  Slovenian = 'SL',
  Spanish = 'ES',
  Swahili = 'SW',
  Swedish = 'SV',
  Tamil = 'TA',
  Telugu = 'TE',
  Thai = 'TH',
  Turkish = 'TR',
  Ukrainian = 'UK',
  Urdu = 'UR',
  Vietnamese = 'VI',
  Welsh = 'CY'
}
